export const AnalyticsActions = {
    STEP_SELECTED: (step) => `Step${ step }Selected`,
    RESULT_CLICKED: (optionId) => `ClickResultId${optionId}`
  }

  export const AnalyticsEvents = {
    CONSULTANT: 'Consultant',
  }
